import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import {
  useSetIsChatEnabledSceneMutation,
  useUserScenesQuery,
} from '../../generated/graphql';
import { useRouter } from 'next/router';
import styles from './text-chat.module.css';

export default function TextChat() {
  const router = useRouter();
  const [switchEnableChatM] = useSetIsChatEnabledSceneMutation();
  const [isChecked, setIsChecked] = useState(false);

  const sceneId = Array.isArray(router.query?.id)
    ? router.query?.id[0]
    : router.query?.id;

  const { data: scene } = useUserScenesQuery({
    variables: {
      where: {
        id: {
          equals: sceneId as string,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (scene?.userScenes[0].isChatEnabled) {
      setIsChecked(true);
    }
  }, [scene?.userScenes[0].isChatEnabled]);

  async function switchEnableChat(checked: boolean) {
    setIsChecked(() => checked);

    await switchEnableChatM({
      variables: {
        where: {
          id: sceneId as string,
          enabled: checked,
        },
      },
    });
  }

  return (
    <div>
      <span className={styles.title}>Text Chat</span>
      <div>
        <span className={styles.subtitle}>
          This feature adds text chat to your world, so users can communicate
          via chat
        </span>
      </div>
      <Switch
        onChange={switchEnableChat}
        checked={isChecked}
        checkedChildren='Enabled'
        unCheckedChildren='Disabled'
      />
    </div>
  );
}
